// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 208px;
  }
}
.custom-invoice-details-skeleton ion-list ion-list-header ion-skeleton-text {
  line-height: 200px;
}

.wallet-skelton .card1 h3 {
  margin: 20px auto 5px auto;
}
.wallet-skelton .card1 h2 {
  margin: 10px auto 20px auto;
}
.wallet-skelton ion-card-header {
  border-bottom: 1px solid #ddd;
}
.wallet-skelton ion-card-header ion-avatar {
  float: right;
  width: 10px;
  height: 0.7em;
}
.wallet-skelton [custom-wallet-card] {
  border-top: 1px solid #ddd;
  padding: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #ddd;
}

.fakeItem h1,
.fakeItem h2,
.fakeItem h3,
.fakeItem p,
.fakeItem ion-select {
  background-color: lightgrey;
  opacity: 0.5;
  height: 0.5em;
  margin-top: 10px;
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar 1s infinite;
  padding: 5px;
}
.fakeItem h1 {
  width: 40%;
  height: 0.5em;
}
.fakeItem h2 {
  width: 80%;
}
.fakeItem h3 {
  width: 50%;
}
.fakeItem p {
  width: 30%;
}
.fakeItem .custom-header-width {
  width: 40% !important;
}
.fakeItem ion-avatar {
  float: left;
  width: 52px;
  height: 52px;
  background-color: #ccc;
  border-radius: 25%;
}
.fakeItem ion-label {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.fakeItem ion-avatar {
  opacity: 0.5;
  height: 1em;
  margin-top: 10px;
  animation: shine-avatar 1s infinite;
  padding: 5px;
  background-size: 600px;
}

.custom-walllet-margin h3 {
  margin: auto;
}
.custom-walllet-margin h2 {
  margin: 10px auto 0px;
}

.custom-trips-status {
  margin: auto;
  padding-left: 10px !important;
}

.trip-srid-design {
  max-width: 10% !important;
  margin: 10px;
}

.custom-right-content {
  max-width: 6% !important;
  padding-right: 20px;
}

.wallet-card-design {
  width: calc(100% - 18px);
  height: calc(100vh - 400px);
  overflow: auto;
}
.wallet-card-design .open-sidemenu-design {
  padding: 0 0 20px 0 !important;
}
.wallet-card-design .fakeItem {
  border: 1px solid #ddd;
  border-top: none;
}

.m-auto {
  margin: auto !important;
}

[max-width-30] {
  max-width: 30%;
  width: 30%;
}

[max-width-40] {
  max-width: 40%;
  width: 40%;
}

[max-width-50] {
  max-width: 50%;
  width: 50%;
}

[max-width-90] {
  max-width: 90%;
  width: 90%;
}

[mb-10] {
  margin-bottom: 10px;
}

.dot {
  height: 15px;
  width: 15px;
  background-color: #ccc;
  border-radius: 50%;
  float: right;
}

.star {
  position: relative;
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 0.9em;
  margin-right: 0.9em;
  margin-bottom: 1.2em;
  border-right: 0.3em solid transparent;
  border-bottom: 0.7em solid rgb(204, 204, 204);
  border-left: 0.3em solid transparent;
  /* Controlls the size of the stars. */
  font-size: 8px;
}
.star:before, .star:after {
  content: "";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  top: 0.6em;
  left: -1em;
  border-right: 1em solid transparent;
  border-bottom: 0.7em solid rgb(204, 204, 204);
  border-left: 1em solid transparent;
  transform: rotate(-35deg);
}
.star:after {
  transform: rotate(35deg);
}

.sectorWise {
  width: 25%;
  margin-left: 16%;
}

.stationWise {
  width: 25%;
  margin-left: 23%;
}

.height {
  height: 28px;
}

.sectorWiseManifest {
  width: 25%;
  margin-left: 37%;
}

.status {
  position: relative;
  left: 43%;
}

.column2 {
  width: 25%;
  height: 27px;
}

.content {
  width: 89%;
  height: 66px;
}

.skeletonWidth {
  height: 10px;
  width: 100%;
}

[width45] {
  width: 45%;
}

[height_10] {
  height: 10px;
}

[width100] {
  width: 100%;
}

[width20] {
  width: 20%;
}

[height20] {
  height: 20px;
}

[width40] {
  width: 40%;
}

[width30] {
  width: 30%;
}

[width10] {
  width: 10%;
}

[ml-4] {
  margin-left: 4%;
}

[mr-8] {
  margin-right: 8%;
}

[width70] {
  width: 70%;
}

[left-15] {
  left: 15%;
}

.box-shadow {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
}

.card-grid {
  width: 100%;
  height: 100% auto;
  margin: 0 auto;
  padding: 10px;
}

.card-column {
  display: flex;
  flex: 1;
  justify-content: center;
  margin-bottom: 20px;
  padding: 10px;
}

.custom-card {
  position: relative;
  width: 100%;
  max-width: 475px;
  height: auto;
  border: 1px solid #dedede;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background-color: #fff;
  margin: auto;
  text-align: center;
}

.cover-image ion-skeleton-text {
  display: block;
}

.profile-image ion-skeleton-text {
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ccc;
  border: 3px solid #e0e0e0;
  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.7);
}

.custom-card ion-card-header {
  margin-top: 30px;
}

ion-card-title {
  left: 30%;
}

ion-card-subtitle {
  left: 25%;
}

.custom-card ion-card-content {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.cardCss {
  height: 100% !important;
}
.cardCss ion-card-header {
  background-color: #d1cbd0;
  padding: 0;
  flex: 0 0 auto;
}
.cardCss ion-card-header .flight-header {
  font-weight: 600;
  font-size: 14px;
  padding: 12px 8px;
  color: #000;
  letter-spacing: 2px;
}

.forward-icon-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  height: 100%;
}
.forward-icon-col .forward-icon {
  font-size: 24px;
  color: var(--ion-color-primary);
}

.doc-icon,
.flight-icon,
.location-icon,
.cancel-icon {
  color: #000000;
  font-size: 20px !important;
  vertical-align: middle;
}

.trip-status-line {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
}

.flight-grid {
  padding: 0;
}
.flight-grid ion-list {
  padding: 0;
}

.skeleton-center {
  display: flex;
  justify-content: center; /* horizontal center */
  align-items: center; /* vertical center */
}

.forward-icon-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  height: 100%;
}
.forward-icon-col .forward-icon {
  font-size: 24px;
  color: var(--ion-color-primary);
}

.trip-row {
  align-items: center;
  padding: 10px 0;
}

.trip-status-col {
  display: flex;
  align-items: center;
}

.trip-summary-card {
  margin: 40px 50px 5px 45px;
  border-radius: 12px;
  border: 1px solid #ccc;
  box-shadow: 0 0px 12px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .trip-summary-card {
    margin: 20px 20px 5px 20px;
    padding: 0px 10px;
  }
}

.trip-card.skeleton-card {
  margin: 20px;
  transition: none;
}
.trip-card.skeleton-card:hover {
  transform: none;
  box-shadow: none;
  background-color: transparent;
}
.trip-card.skeleton-card ion-card-header {
  padding: 12px;
}
.trip-card.skeleton-card ion-card-content {
  padding: 12px;
}

.mbl-pad {
  padding: 0;
}
@media (max-width: 768px) {
  .mbl-pad {
    padding: 0;
  }
}

@media (max-width: 768px) {
  .card-grid {
    padding: 8px 15px !important;
  }
  .card-grid ion-col {
    padding: 4px !important;
  }
  .trip-card.skeleton-card {
    margin: 10px 5px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/skelton/skelton.component.scss"],"names":[],"mappings":"AAcA;EACE;IACE,0BAAA;EAbF;EAgBA;IAEE,0BAAA;EAfF;AACF;AAmBI;EACE,kBAAA;AAjBN;;AAuBI;EACE,0BAAA;AApBN;AAsBI;EACE,2BAAA;AApBN;AAwBE;EACE,6BAAA;AAtBJ;AAuBI;EACE,YAAA;EACA,WAAA;EACA,aAAA;AArBN;AAwBE;EACE,0BAAA;EACA,aAAA;EACA,cAAA;EACA,6BAAA;AAtBJ;;AA0BE;;;;;EAKE,2BAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EA3DF,2EAAA;EAMA,sBAAA;EAuDE,mCAAA;EACA,YAAA;AAtBJ;AAyBE;EACE,UAAA;EACA,aAAA;AAvBJ;AA0BE;EACE,UAAA;AAxBJ;AA2BE;EACE,UAAA;AAzBJ;AA4BE;EACE,UAAA;AA1BJ;AA4BE;EACE,qBAAA;AA1BJ;AA4BE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AA1BJ;AA6BE;EACE,2BAAA;EACA,8BAAA;AA3BJ;AA8BE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mCAAA;EACA,YAAA;EACA,sBAAA;AA5BJ;;AAgCE;EACE,YAAA;AA7BJ;AA+BE;EACE,qBAAA;AA7BJ;;AAgCA;EACE,YAAA;EACA,6BAAA;AA7BF;;AA+BA;EACE,yBAAA;EACA,YAAA;AA5BF;;AA8BA;EACE,wBAAA;EACA,mBAAA;AA3BF;;AA6BA;EACE,wBAAA;EACA,2BAAA;EACA,cAAA;AA1BF;AA2BE;EACE,8BAAA;AAzBJ;AA2BE;EACE,sBAAA;EACA,gBAAA;AAzBJ;;AA4BA;EACE,uBAAA;AAzBF;;AA2BA;EACE,cAAA;EACA,UAAA;AAxBF;;AA0BA;EACE,cAAA;EACA,UAAA;AAvBF;;AAyBA;EACE,cAAA;EACA,UAAA;AAtBF;;AAwBA;EACE,cAAA;EACA,UAAA;AArBF;;AAuBA;EACE,mBAAA;AApBF;;AAsBA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAnBF;;AAqBA;EACE,kBAAA;EAEA,qBAAA;EACA,QAAA;EACA,SAAA;EAEA,kBAAA;EACA,mBAAA;EACA,oBAAA;EAEA,qCAAA;EACA,6CAAA;EACA,oCAAA;EAEA,qCAAA;EACA,cAAA;AAtBF;AAwBE;EAEE,WAAA;EAEA,cAAA;EACA,QAAA;EACA,SAAA;EAEA,kBAAA;EACA,UAAA;EACA,UAAA;EAEA,mCAAA;EACA,6CAAA;EACA,kCAAA;EAEA,yBAAA;AA3BJ;AA8BE;EACE,wBAAA;AA5BJ;;AAgCA;EACE,UAAA;EACA,gBAAA;AA7BF;;AA+BA;EACE,UAAA;EACA,gBAAA;AA5BF;;AA8BA;EACE,YAAA;AA3BF;;AA6BA;EACE,UAAA;EACA,gBAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,SAAA;AA1BF;;AA8BA;EACE,UAAA;EACA,YAAA;AA3BF;;AA6BA;EACE,UAAA;EACA,YAAA;AA1BF;;AA6BA;EACE,YAAA;EACA,WAAA;AA1BF;;AA6BA;EACE,UAAA;AA1BF;;AA6BA;EACE,YAAA;AA1BF;;AA6BA;EACE,WAAA;AA1BF;;AA4BA;EACE,UAAA;AAzBF;;AA2BA;EACE,YAAA;AAxBF;;AA2BA;EACE,UAAA;AAxBF;;AA2BA;EACE,UAAA;AAxBF;;AA2BA;EACE,UAAA;AAxBF;;AA0BA;EACE,eAAA;AAvBF;;AAyBA;EACE,gBAAA;AAtBF;;AAwBA;EACE,UAAA;AArBF;;AAuBA;EACE,SAAA;AApBF;;AAwBA;EACE,yCAAA;AArBF;;AAwBA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AArBF;;AAwBA;EACE,aAAA;EACA,OAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,wCAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,cAAA;AArBF;;AAwBA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,yBAAA;EACA,0CAAA;AArBF;;AAwBA;EACE,gBAAA;AArBF;;AAwBA;EACE,SAAA;AArBF;;AAwBA;EACE,SAAA;AArBF;;AAwBA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AArBF;;AAuBA;EACE,uBAAA;AApBF;AAqBE;EACE,yBAAA;EACA,UAAA;EACA,cAAA;AAnBJ;AAqBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AAnBN;;AAuBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AApBF;AAsBE;EACE,eAAA;EACA,+BAAA;AApBJ;;AAuBA;;;;EAIE,cAAA;EACA,0BAAA;EACA,sBAAA;AApBF;;AAsBA;EACE,aAAA;EAEA,mBAAA;EACA,eAAA;EACA,YAAA;AApBF;;AAsBA;EACE,UAAA;AAnBF;AAqBE;EACE,UAAA;AAnBJ;;AAsBA;EACE,aAAA;EACA,uBAAA,EAAA,sBAAA;EACA,mBAAA,EAAA,oBAAA;AAnBF;;AAqBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAlBF;AAoBE;EACE,eAAA;EACA,+BAAA;AAlBJ;;AAqBA;EACE,mBAAA;EACA,eAAA;AAlBF;;AAoBA;EACE,aAAA;EACA,mBAAA;AAjBF;;AAmBA;EACE,0BAAA;EACA,mBAAA;EACA,sBAAA;EACA,yCAAA;AAhBF;AAiBE;EALF;IAMI,0BAAA;IACA,iBAAA;EAdF;AACF;;AAgBA;EACE,YAAA;EACA,gBAAA;AAbF;AAcE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AAZJ;AAcE;EACE,aAAA;AAZJ;AAcE;EACE,aAAA;AAZJ;;AAeA;EACE,UAAA;AAZF;AAaE;EAFF;IAGI,UAAA;EAVF;AACF;;AAYA;EACE;IACE,4BAAA;EATF;EAUE;IACE,uBAAA;EARJ;EAWA;IACE,2BAAA;EATF;AACF","sourcesContent":["$avatar-offset: 52+16;\n$animation-duration: 1s;\n$base-color: #ddd;\n$shine-color: #e8e8e8;\n\n@mixin background-gradient {\n  background-image: linear-gradient(\n    90deg,\n    $base-color 0px,\n    $shine-color 40px,\n    $base-color 80px\n  );\n  background-size: 600px;\n}\n@keyframes shine-avatar {\n  0% {\n    background-position: -100px + $avatar-offset;\n  }\n\n  40%,\n  100% {\n    background-position: 140px + $avatar-offset;\n  }\n}\n.custom-invoice-details-skeleton {\n  ion-list {\n    ion-list-header ion-skeleton-text {\n      line-height: 200px;\n    }\n  }\n}\n.wallet-skelton {\n  .card1 {\n    h3 {\n      margin: 20px auto 5px auto;\n    }\n    h2 {\n      margin: 10px auto 20px auto;\n    }\n  }\n\n  ion-card-header {\n    border-bottom: 1px solid #ddd;\n    ion-avatar {\n      float: right;\n      width: 10px;\n      height: 0.7em;\n    }\n  }\n  [custom-wallet-card] {\n    border-top: 1px solid #ddd;\n    padding: 10px;\n    margin: 10px 0;\n    border-bottom: 1px solid #ddd;\n  }\n}\n.fakeItem {\n  h1,\n  h2,\n  h3,\n  p,\n  ion-select {\n    background-color: lightgrey;\n    opacity: 0.5;\n    height: 0.5em;\n    margin-top: 10px;\n    @include background-gradient;\n    animation: shine-avatar $animation-duration infinite;\n    padding: 5px;\n  }\n\n  h1 {\n    width: 40%;\n    height: 0.5em;\n  }\n\n  h2 {\n    width: 80%;\n  }\n\n  h3 {\n    width: 50%;\n  }\n\n  p {\n    width: 30%;\n  }\n  .custom-header-width {\n    width: 40% !important;\n  }\n  ion-avatar {\n    float: left;\n    width: 52px;\n    height: 52px;\n    background-color: #ccc;\n    border-radius: 25%;\n  }\n\n  ion-label {\n    padding-top: 5px !important;\n    padding-bottom: 5px !important;\n  }\n\n  ion-avatar {\n    opacity: 0.5;\n    height: 1em;\n    margin-top: 10px;\n    animation: shine-avatar $animation-duration infinite;\n    padding: 5px;\n    background-size: 600px;\n  }\n}\n.custom-walllet-margin {\n  h3 {\n    margin: auto;\n  }\n  h2 {\n    margin: 10px auto 0px;\n  }\n}\n.custom-trips-status {\n  margin: auto;\n  padding-left: 10px !important;\n}\n.trip-srid-design {\n  max-width: 10% !important;\n  margin: 10px;\n}\n.custom-right-content {\n  max-width: 6% !important;\n  padding-right: 20px;\n}\n.wallet-card-design {\n  width: calc(100% - 18px);\n  height: calc(100vh - 400px);\n  overflow: auto;\n  .open-sidemenu-design {\n    padding: 0 0 20px 0 !important;\n  }\n  .fakeItem {\n    border: 1px solid #ddd;\n    border-top: none;\n  }\n}\n.m-auto {\n  margin: auto !important;\n}\n[max-width-30] {\n  max-width: 30%;\n  width: 30%;\n}\n[max-width-40] {\n  max-width: 40%;\n  width: 40%;\n}\n[max-width-50] {\n  max-width: 50%;\n  width: 50%;\n}\n[max-width-90] {\n  max-width: 90%;\n  width: 90%;\n}\n[mb-10] {\n  margin-bottom: 10px;\n}\n.dot {\n  height: 15px;\n  width: 15px;\n  background-color: #ccc;\n  border-radius: 50%;\n  float: right;\n}\n.star {\n  position: relative;\n\n  display: inline-block;\n  width: 0;\n  height: 0;\n\n  margin-left: 0.9em;\n  margin-right: 0.9em;\n  margin-bottom: 1.2em;\n\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.7em solid rgb(204, 204, 204);\n  border-left: 0.3em solid transparent;\n\n  /* Controlls the size of the stars. */\n  font-size: 8px;\n\n  &:before,\n  &:after {\n    content: \"\";\n\n    display: block;\n    width: 0;\n    height: 0;\n\n    position: absolute;\n    top: 0.6em;\n    left: -1em;\n\n    border-right: 1em solid transparent;\n    border-bottom: 0.7em solid rgb(204, 204, 204);\n    border-left: 1em solid transparent;\n\n    transform: rotate(-35deg);\n  }\n\n  &:after {\n    transform: rotate(35deg);\n  }\n}\n// For Trip Info\n.sectorWise {\n  width: 25%;\n  margin-left: 16%;\n}\n.stationWise {\n  width: 25%;\n  margin-left: 23%;\n}\n.height {\n  height: 28px;\n}\n.sectorWiseManifest {\n  width: 25%;\n  margin-left: 37%;\n}\n\n.status {\n  position: relative;\n  left: 43%;\n}\n\n// For TripInfo Schedule\n.column2 {\n  width: 25%;\n  height: 27px;\n}\n.content {\n  width: 89%;\n  height: 66px;\n}\n\n.skeletonWidth {\n  height: 10px;\n  width: 100%;\n}\n\n[width45] {\n  width: 45%;\n}\n\n[height_10] {\n  height: 10px;\n}\n\n[width100] {\n  width: 100%;\n}\n[width20] {\n  width: 20%;\n}\n[height20] {\n  height: 20px;\n}\n\n[width40] {\n  width: 40%;\n}\n\n[width30] {\n  width: 30%;\n}\n\n[width10] {\n  width: 10%;\n}\n[ml-4] {\n  margin-left: 4%;\n}\n[mr-8] {\n  margin-right: 8%;\n}\n[width70] {\n  width: 70%;\n}\n[left-15] {\n  left: 15%;\n}\n\n//Available Aircraft\n.box-shadow {\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);\n}\n\n.card-grid {\n  width: 100%;\n  height: 100% auto;\n  margin: 0 auto;\n  padding: 10px;\n}\n\n.card-column {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  margin-bottom: 20px;\n  padding: 10px;\n}\n\n.custom-card {\n  position: relative;\n  width: 100%;\n  max-width: 475px;\n  height: auto;\n  border: 1px solid #dedede;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  background-color: #fff;\n  margin: auto;\n  text-align: center;\n}\n\n.cover-image ion-skeleton-text {\n  display: block;\n}\n\n.profile-image ion-skeleton-text {\n  position: absolute;\n  top: 120px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #ccc;\n  border: 3px solid #e0e0e0;\n  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.7);\n}\n\n.custom-card ion-card-header {\n  margin-top: 30px;\n}\n\nion-card-title {\n  left: 30%;\n}\n\nion-card-subtitle {\n  left: 25%;\n}\n\n.custom-card ion-card-content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.cardCss {\n  height:100% !important;\n  ion-card-header {\n    background-color: #d1cbd0;\n    padding: 0;\n    flex: 0 0 auto;\n\n    .flight-header {\n      font-weight: 600;\n      font-size: 14px;\n      padding: 12px 8px;\n      color: #000;\n      letter-spacing: 2px;\n    }\n  }\n}\n.forward-icon-col {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n  height: 100%;\n\n  .forward-icon {\n    font-size: 24px;\n    color: var(--ion-color-primary);\n  }\n}\n.doc-icon,\n.flight-icon,\n.location-icon,\n.cancel-icon {\n  color: #000000;\n  font-size: 20px !important;\n  vertical-align: middle;\n}\n.trip-status-line{\n  display: flex;\n  // justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n  height: 100%;\n}\n.flight-grid {\n  padding: 0;\n\n  ion-list {\n    padding: 0;\n  }\n}\n.skeleton-center {\n  display: flex;\n  justify-content: center; /* horizontal center */\n  align-items: center;     /* vertical center */\n}\n.forward-icon-col {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  cursor: pointer;\n  height: 100%;\n\n  .forward-icon {\n    font-size: 24px;\n    color: var(--ion-color-primary);\n  }\n}\n.trip-row {\n  align-items: center;\n  padding: 10px 0;\n}\n.trip-status-col {\n  display: flex;\n  align-items: center;\n}\n.trip-summary-card {\n  margin: 40px 50px 5px 45px;\n  border-radius: 12px;\n  border: 1px solid #ccc;\n  box-shadow: 0 0px 12px rgba(0, 0, 0, 0.1);\n  @media (max-width: 768px) {\n    margin: 20px 20px 5px 20px;\n    padding: 0px 10px;\n  }\n}\n.trip-card.skeleton-card {\n  margin: 20px;\n  transition: none;\n  &:hover {\n    transform: none;\n    box-shadow: none;\n    background-color: transparent;\n  }\n  ion-card-header {\n    padding: 12px;\n  }\n  ion-card-content {\n    padding: 12px;\n  }\n}\n.mbl-pad {\n  padding: 0;\n  @media (max-width: 768px) {\n    padding: 0;\n  }\n}\n@media (max-width: 768px) {\n  .card-grid {\n    padding: 8px 15px !important;\n    ion-col {\n      padding: 4px !important;\n    }\n  }\n  .trip-card.skeleton-card {\n    margin: 10px 5px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
